import React, { Component } from 'react';
import userService from "../../services/user.services";
import { toast, ToastContainer } from 'react-toastify';
import AuthService from '../../services/auth.service';
import Form from "react-validation/build/form";
import { Link } from 'react-router-dom';
import { Button, Row,Modal, ModalBody, ModalHeader } from 'reactstrap';
import Select, { createFilter } from 'react-select';
import { matchSorter } from 'match-sorter';
import ReactTable from 'react-table';


const required = value => {
    if (!value) {
        return (
            <div className="alert alert-danger" role="alert">
                This field is required!
            </div>
        );
    }
};

const customStyles = {
    control: base => ({
        ...base,
        height: 48,
        minHeight: 48,
        maxMenuHeight: 200
    })
};

class BrandSubbrandWiseDeactivation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fieldvalue: {'brand' :'','subBrand':'','seasonId':localStorage.getItem('seasonId')},
            submitted: false,
            successful: false,
            message: "",
            brand: '',
            subBrand: '',
            submitted: false,
            successful: false,
            message: "",
            brandData: [],
            optionsBrand: [],
            brandSelectedValue: '',
            subBrandData: [],
            optionsSubBrand: [],
            subBrandSelectedValue: '',
            brandSubBrandDataList: [],
            modal3: false,
            modal4: false,
            previousStatus: '',
          
           
        }

        this.toggle3 = this.toggle3.bind(this);
        this.toggle4 = this.toggle4.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }


    toggle3() {
        this.setState(prevState => ({
            modal3: !prevState.modal3
        }));
    }

    toggle4() {
        this.setState(prevState => ({
            modal4: !prevState.modal4
        }));
    }

    brandSubBrandWiseListing = () => {
    
            userService.brandSubBrandWiseListing(localStorage.getItem('seasonId')).then(response => {
                    if (response.data['status'] === 'SUCCESS') {    
                        this.setState({
                            brandSubBrandDataList: JSON.parse(response.data['jsonObject']),
                        })    
                    } 
                }).catch(error => {
                    toast.warn("Error occured, contact support")
                        console.log('error ', error)
                 })
        }


    
        handleSubmit(event) {
                event.preventDefault();
        
                this.setState({
                    message: "",
                    successful: false,
                    submitted: true,
        
                });
        
                if (this.state.fieldvalue.brand !== '' && this.state.fieldvalue.subBrand !== '') {
                    userService.saveBrandSubbrandWiseData(this.state.fieldvalue).then(
                        response => {
                            if (response.data['status'] === 'SUCCESS') {

                                this.setState({ submitted:false, fieldvalue :{'brand' :'','subBrand':'','seasonId':localStorage.getItem('seasonId')},
                                    subBrandSelectedValue: '',brandSelectedValue:''
                                })
                                toast.success(response.data['message']);

                            } else if (response.data['status'] === 'Error') {
                                toast.error(response.data['message']);
                            }

                            this.brandSubBrandWiseListing();
                        },
                    ).catch(error => {
                        if (error.response.status === 403) {
                            alert('Your Login Session Is Expire ,Please Login ')
                            AuthService.logout()
                            this.props.history.push('/')
                        } else {
                            console.log('error ', error)
                        }
                    })
                }

      
        }


    componentWillMount() {
        this.getBrandDropdownData();
        this.getSubBrandDropdownData();
        this.brandSubBrandWiseListing();
      
    }

        getBrandDropdownData() {
            userService.getBrandDropdownData().then(response =>
                this.setState({
                    brandData: JSON.parse(response.data.jsonObject),
                    optionsBrand: JSON.parse(response.data.jsonObject),
                })
            ).catch(error => {
                if (error.response.status === 403) {
                    alert('Your Login Session Is Expire ,Please Login ')
                    AuthService.logout()
                    this.props.history.push('/')
                } else {
                    console.log('error ', error)
                }
            })
    }
    
    
        getSubBrandDropdownData() {
            userService.getSubBrandDropdownData().then(response =>
                this.setState({
                    subBrandData: JSON.parse(response.data.jsonObject),
                    optionsSubBrand: JSON.parse(response.data.jsonObject),
                })
            ).catch(error => {
                if (error.response.status === 403) {
                    alert('Your Login Session Is Expire ,Please Login ')
                    AuthService.logout()
                    this.props.history.push('/')
                } else {
                    console.log('error ', error)
                }
            })
        }

        getAllDropdownFunc(value, field) {
            let fieldvalue = this.state.fieldvalue;
            fieldvalue[field] = value.value;
    
            if (field === 'brand') {
                this.setState({ fieldvalue, brandSelectedValue: value });
            } else if (field === 'subBrand') {
                this.setState({ fieldvalue, subBrandSelectedValue: value });
            } 

            
    
    }

    
    activeDeactiveRow(e, id, status) {

        this.setState({
            id: id,
            previousStatus:status
        });

        if (status === 'Active') {
                this.toggle3();
            } else {
                this.toggle4();
        }

        }
    
        activeDeactiveBrandSubBrandWiseData(e,id,status) { 
          userService.activeDeactiveBrandSubBrandWiseData(id).then(response => {
                    
              if (response.data['status'] === 'SUCCESS') {
                  if (status === 'Active') {
                      toast.error("Record deactive successfully")
                  } else { 
                      toast.success("Record active successfully")
                  }
                            
                  this.brandSubBrandWiseListing();
                       }
        
                        if (response.data['status'] === 'Error') {
                            
                            toast.warn(response.data['message'])
                        }
                    
                }).catch(error => {
        
                    if (error.response.status === 403) {
                        alert('Your Login Session Is Expire ,Please Login ');
                        AuthService.logout();
                        this.props.history.push('/');
                    } else {
                        console.log('error ', error)
                    }
        
                })
    }

    deleteBrandSubBrandWiseData(e, id) { 
        this.setState({
            id: id,
        });

         this.toggle3();
    }
    
    deleteData() { 
         userService.deleteBrandSubBrandWiseData(this.state.id).then(response => {
                    
              if (response.data['status'] === 'SUCCESS') {
                      toast.error("Record delete successfully")
                            
                      this.brandSubBrandWiseListing(localStorage.getItem('seasonId'));
    this.toggle3();
                        }
        
                        if (response.data['status'] === 'Error') {
                            toast.warn(response.data['message'])
                        }
                    
                }).catch(error => {
        
                    if (error.response.status === 403) {
                        alert('Your Login Session Is Expire ,Please Login ');
                        AuthService.logout();
                        this.props.history.push('/');
                    } else {
                        console.log('error ', error)
                    }
        
                })
    }
    
    render() {

        const { submitted, fieldvalue, brandSelectedValue, subBrandSelectedValue } = this.state;
        
        const columns = [
        
                    // {
                    //     width: 160,
                    //     Header: 'Active/Deactive',
                    //     accessor: 'action2',
                    //     Cell: props => {
                    //         return (
                    //             <div className='d-flex justify-content-center'>
                    //                 <Link className="btn btn-outline-info" onClick={(e) => this.activeDeactiveRow(e, props.original.id,props.original.status)}
                    //                     href="#"><i className="fa fa-edit"></i></Link>
                    //             </div>
                    //         )
                    //     },
                    // },
              
                    {
                        sortable: false,
                        Header: 'Brand',
                        accessor: 'brand',
                        filterMethod: (filter, rows) =>
                            matchSorter(rows, filter.value, { keys: ["brand"] }),
                        filterAll: true,
                    },
                    {
                        Header: 'Sub Brand',
                        accessor: 'subBrand',
                        filterMethod: (filter, rows) =>
                            matchSorter(rows, filter.value, { keys: ["subBrand"] }),
                        filterAll: true,
                    },
            // {
            //     width: 80,
            //             Header: 'Deactive',
            //             accessor: 'deactive',
            //              Cell: props => {
            //         return (
            //             <div className='d-flex justify-content-center'>
            //                 <input type="checkbox" defaultChecked={props.original.deactive} checked={props.original.deactive}
            //                     value={props.original.deactive} onClick={(e) => this.activeDeactiveBrandSubBrandWiseData(e, props.original.id,props.original.status)}
            //                 />
            //             </div>
            //         )
            //     },
            // },
            
              {
                            width: 60,
                            Header: 'Delete',
                            accessor: 'action2',
                            Cell: props => {
                                return (
                                    <div className='d-flex justify-content-center'>
                                        <Link className="btn btn-outline-danger" onClick={(e) => this.deleteBrandSubBrandWiseData(e, props.original.id)}
                                            href="#"><i className="fa fa-trash-o"></i></Link>
                                    </div>
                                )
                            },
                        },
                   
                 
                 
                  
        
        
                ]
        
        return (
            <>
               <div className="container">
                               <ToastContainer autoClose={2000} draggable={false} />
                               <div className="col-md-12 ">
                                   <Row style={{ paddingTop: "10px" }}>
                                       <div className="col-md-11">
                                           <h3 style={{ "text-align": "left", color: "navy" }}> Brand SubBrand Wise Data </h3>
                                       </div>
                                       
                        </Row>

                        <Form onSubmit={this.handleSubmit}>
                            <div className="row">


                            <div className={'form-group col-md-3 '}>
                                <label style={{ fontWeight: "bold" }}>Brand </label>
                                <Select name="brand" styles={customStyles}
                                    defaultValue="Select Brand"
                                    options={this.state.optionsBrand}
                                    value={brandSelectedValue}
                                    onChange={(e) => this.getAllDropdownFunc(e, 'brand')}
                                />
                                {submitted && !fieldvalue.brand &&
                                    <div className="alert alert-danger" role="alert">
                                        This field is required!
                                    </div>
                                }

                            </div>

                            <div className={'form-group col-md-3 '}>
                                <label style={{ fontWeight: "bold" }}>SubBrand </label>
                                <Select name="subBrand" styles={customStyles}
                                    defaultValue="Select SubBrand"
                                    options={this.state.optionsSubBrand}
                                    value={subBrandSelectedValue}
                                    onChange={(e) => this.getAllDropdownFunc(e, 'subBrand')}
                                />
                                {submitted && !fieldvalue.subBrand &&
                                    <div className="alert alert-danger" role="alert">
                                        This field is required!
                                    </div>
                                }

                                </div>
                                

                                <div className={'form-group col-md-3 '} style={{marginTop:'30px'}}>
                                <button className="btn btn-outline-success">Save</button>
                                    </div>


                            
                                
                            </div>
                        </Form> 

                        <hr></hr>
                        
                        <Row style={{ paddingTop: "10px" }}>
                            <div className='col-md-12'>
                       
                                      <ReactTable className="brandSubBrandList-table"
                                                                        data={this.state.brandSubBrandDataList}
                                                                        columns={columns}
                                                                        filterable defaultFilterMethod={(filter, row) =>
                                                                            String(row[filter.id]) === filter.value}
                                                                        
                                    showPagination={false}
                                    style={{
                                        height: "350px"
                                    }}
                                                                      
                                                                    />
                                    </div>
                                    
                        </Row>


                          {/* modal-Active */}
                                                        <Modal isOpen={this.state.modal4} toggle={this.toggle4} className="modal-login modal-md modal-dialog-centered">
                                                            <ModalHeader toggle={this.toggle4}>
                                                                        <h4 className="mb-0">Do you want to active ? </h4>
                                                            </ModalHeader>
                        
                                                            <ModalBody>
                                                                <div className="success-screen">
                                                                    <div className="row">
                                                                        <div className="col-md-2" style={{ paddingLeft: "15px" }}>
                                                                            <Button style={{ paddingTop: "5px" }} outline color="primary" onClick={(e) => this.activeDeactiveBrandSubBrandWiseData(e)}>Yes</Button>&nbsp;
                                                                        </div>
                                                                        <div className="col-md-2" >
                                                                            <Button style={{ paddingTop: "5px" }} outline color="danger" onClick={this.toggle4}>No</Button>&nbsp;
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </ModalBody>
                        </Modal>
                        

                           {/* modal-Deactive */}
                           <Modal isOpen={this.state.modal3} toggle={this.toggle3} className="modal-login modal-md modal-dialog-centered">
                                                            <ModalHeader toggle={this.toggle3}>
                                                                        <h4 className="mb-0">Do you want to delete?</h4>
                                                            </ModalHeader>
                        
                                                            <ModalBody>
                                                                <div className="success-screen">
                                                                    <div className="row">
                                                                        <div className="col-md-2" style={{ paddingLeft: "15px" }}>
                                                                            <Button style={{ paddingTop: "5px" }} outline color="primary" onClick={(e) => this.deleteData(e)}>Yes</Button>&nbsp;
                                                                        </div>
                                                                        <div className="col-md-2" >
                                                                            <Button style={{ paddingTop: "5px" }} outline color="danger" onClick={this.toggle3}>No</Button>&nbsp;
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </ModalBody>
                                                        </Modal>

                        
                    </div>
                   </div> 
            </>
        )
    }

}

export default BrandSubbrandWiseDeactivation;